// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-site-gatsby/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-js": () => import("/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-site-gatsby/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-404-js": () => import("/home/gitlab-runner/builds/_wi3V95W/0/poz/pozitiff-site-gatsby/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

